import { render, staticRenderFns } from "./visit-data.vue?vue&type=template&id=5b224e74&"
import script from "./visit-data.vue?vue&type=script&lang=js&"
export * from "./visit-data.vue?vue&type=script&lang=js&"
import style0 from "./visit-data.vue?vue&type=style&index=0&id=5b224e74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports